import BaseApp from '../BaseApp.vue'
import MangoPageBlock from './templates/MangoPageBlock.vue';
import Page8800 from './templates/Page8800.vue';


let template = window['NumbersPageBlockData']['template'];

if (template === 'MangoPageBlock') {
    BaseApp.methods.mountApp(MangoPageBlock);
} else {
    BaseApp.methods.mountApp(Page8800);
}